import { apiConfig } from "../apiConfig"
import useFetchClient from "./useFetchClient"
import { CompanyGroupPortalUser, CreateCompanyGroupPortalUserModel, UpdateCompanyGroupPortalUserModel } from "../redux/types";
import { useAppDispatch } from "../redux/hooks";
import {
    loading,
    portalUserCreated,
    portalUserCreateFailure,
    portalUserDeleted,
    portalUserDeleteFailure,
    portalUsersFetched,
    portalUsersFetchFailure,
    portalUserUpdated,
    portalUserUpdateFailure
} from "../redux/slices/companyGroupPortalUserSlice";

const useCompanyGroupPortalUserActions = () => {
    const fetchClient = useFetchClient()
    const dispatch = useAppDispatch()

    const getUsers = () => {
        dispatch(loading())

        return fetchClient.get(apiConfig.routes.companyGroupUsers)
            .then(response => {
                dispatch(portalUsersFetched(response.data as CompanyGroupPortalUser[]))
            })
            .catch(error => {
                console.log('getUsers error:', error)
                dispatch(portalUsersFetchFailure(error))
            })
    }

    const createUser = (user: CreateCompanyGroupPortalUserModel) => {
        dispatch(loading())

        return fetchClient.post(apiConfig.routes.companyGroupUsers, user)
            .then(response => {
                dispatch(portalUserCreated(response.data as CompanyGroupPortalUser))
            })
            .catch(error => {
                console.log('createUser error:', error)
                dispatch(portalUserCreateFailure(error))
            })
    }

    const updateUser = (portalUserId: string, user: UpdateCompanyGroupPortalUserModel) => {
        dispatch(loading())
        const url = `${apiConfig.routes.companyGroupUsers}${portalUserId}`

        return fetchClient.post(url, user)
            .then(response => {
                dispatch(portalUserUpdated(response.data as CompanyGroupPortalUser))
            })
            .catch(error => {
                console.log('updateUser error:', error)
                dispatch(portalUserUpdateFailure(error))
            })
    }

    const deleteUser = (user: CompanyGroupPortalUser) => {
        dispatch(loading())
        const url = `${apiConfig.routes.companyGroupUsers}${user.portalUserId}`

        return fetchClient.delete(url)
            .then(response => {
                dispatch(portalUserDeleted(user))
            })
            .catch(error => {
                console.log('deleteUser error:', error)
                dispatch(portalUserDeleteFailure(error))
            })
    }

    return {
        getUsers,
        createUser,
        updateUser,
        deleteUser
    }
}

export default useCompanyGroupPortalUserActions
